import { css } from '@emotion/css';
import { Layout } from '../../../shared/components/layout/Layout';
import { h1Style } from '../../../shared/styles/text';
import { useUser } from '../../../shared/providers/user-provider';
import { TextInput } from '../../../shared/components/TextInput';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '../../../shared/components/Button';
import { ChevronLeft } from '../../../shared/assets/icons';
import { useNavigator } from '../../../routing/navigator';
import { UpdateMyUsernameParams } from '../../../shared/types/input-param-types';
import { useState } from 'react';
import { useUpdateMyUsername } from '../../../shared/services/api/user';
import { showPrivateToast } from '../../../shared/utils/show-private-toast';

const validationSchema = yup.object({
  username: yup.string().required(),
});

export const ChangeUsernamePage = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigator = useNavigator();
  const user = useUser();
  const updateMyUsername = useUpdateMyUsername();

  const methods = useForm({
    defaultValues: {
      username: user?.username || '',
    } as UpdateMyUsernameParams,
    resolver: yupResolver(validationSchema) as any,
    mode: 'all',
  });

  const handlePersonalInformationUpdate: SubmitHandler<
    UpdateMyUsernameParams
  > = async (data: UpdateMyUsernameParams) => {
    try {
      setIsLoading(true);
      await updateMyUsername(data);
      showPrivateToast('Username updated successfully.');
      navigator.toAccount();
    } catch (err: any) {
      showPrivateToast('Something went wrong.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout.Content className={emailPageStyle}>
      <Button
        startIcon={<ChevronLeft />}
        variant={ButtonVariantEnum.TEXT}
        size={ButtonSizeEnum.LARGE}
        text={`account`}
        className={backButtonStyle}
        onClick={navigator.toPrevious}
      />
      <div className={emailPageHeaderStyle}>
        <h1>Change Username</h1>
      </div>
      <FormProvider {...methods}>
        <form
          className={formStyle}
          onSubmit={methods.handleSubmit(handlePersonalInformationUpdate)}
        >
          <TextInput
            placeHolder={'New username'}
            name="username"
            markAsRequired={true}
          />
          <Button
            disabled={isLoading}
            variant={ButtonVariantEnum.FILLED}
            size={ButtonSizeEnum.LARGE}
            fullWidth={true}
            text="next"
            type={'submit'}
            loading={isLoading}
            className={submitButtonStyle}
          />
        </form>
      </FormProvider>
    </Layout.Content>
  );
};

const formStyle = css`
  padding-top: 2rem;
`;

const emailPageStyle = css`
  padding-top: 0.625rem;
`;

const backButtonStyle = css`
  padding-top: 0rem;
  margin-bottom: 2rem;
`;

const submitButtonStyle = css`
  margin-top: 1.5rem;
`;

const emailPageHeaderStyle = css`
  h1 {
    ${h1Style}
    margin-bottom: 1rem;
  }
`;
